import { motion } from "framer-motion";

const SelectedWorkHeader = () => {
  return (
    <section
      aria-label="Selected Work intro"
      className="relative border-y border-border overflow-hidden"
    >
      {/* Hairline accent */}
      <motion.div
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.1, ease: [0.25, 0.4, 0.25, 1] }}
        className="absolute top-0 left-0 h-px w-full bg-gradient-to-r from-transparent via-foreground/40 to-transparent origin-left"
      />

      <div className="px-6 md:px-12 py-5 md:py-6">
        <div className="flex items-center justify-between gap-6">
          {/* Left, index + label */}
          <motion.div
            initial={{ opacity: 0, x: -8 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, ease: [0.25, 0.4, 0.25, 1] }}
            className="flex items-baseline gap-3 md:gap-4 min-w-0"
          >
            <span className="font-mono text-[10px] md:text-xs text-accent tabular-nums">01</span>
            <h2 className="font-display uppercase tracking-[0.04em] text-foreground text-[15px] md:text-lg leading-none truncate">
              Selected Work
            </h2>
          </motion.div>

          {/* Right, meta */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="hidden md:flex items-center gap-4 font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground/70"
          >
            <span>Selected engagements · 2018-2026</span>
          </motion.div>

          {/* Mobile meta */}
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="md:hidden font-mono text-[9px] uppercase tracking-[0.18em] text-muted-foreground/60 shrink-0"
          >
            2018-26
          </motion.span>
        </div>
      </div>
    </section>
  );
};

export default SelectedWorkHeader;
